export default { sha: '42de7f71077a6081d2335a3842ebe5961293ca5e', buildNumber: 'undefined' }
